var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gst-event-ticket-image u-height-100"},[_c('EventTicketVenueImage',{staticClass:"u-height-100",attrs:{"venue-seat-map-src":_vm.venueMapUrl,"venue-map-src":_vm.venueDetails.defaultMapUrl,"image-props":{
            src: _vm.venueMapUrl,
            height: '100%',
            width: '100%',
            contain: true,
            'aspect-ratio': 1,
        },"image-url-no-seats":_vm.imageUrlNoSeats,"loading":_vm.loadingTickets}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }